import api from ".";

export const obterAmbientes = async (obj) => {
    try {
        const { data } = await api.post("ambiente/obterAmbientes", obj);
        return data;
    } catch (error) {
        console.error(error);
        return error;
    }
};
